// extracted by mini-css-extract-plugin
module.exports = {"color-pink":"#FF6E75","container":"HasNotice_container__3H9KD"};